import type { ElementType } from "react";
import { IconArrowRight, IconClock, IconTrash } from "@tabler/icons-react";
import Text from "../../UI/Text";
import IconButton from "../../UI/IconButton";
import styles from "./PriorityActionItem.module.css";

interface PriorityActionItemProps {
  icon: ElementType;
  title: string;
  subtitle?: string;
  onAction?: () => void;
  onDelete?: () => void;
  onSnooze?: () => void;
  deleteTooltip?: string;
  actionTooltip?: string;
  snoozeTooltip?: string;
}

export default function PriorityActionItem({
  icon: Icon,
  title,
  subtitle,
  onAction,
  onDelete,
  onSnooze,
  deleteTooltip = "Supprimer",
  actionTooltip = "Continuer",
  snoozeTooltip = "Me le rappeler le…",
}: PriorityActionItemProps) {
  return (
    <div className={styles.item}>
      <Text as="div" color="info" background className={styles.itemIcon}>
        <Icon size={20} />
      </Text>
      <div className={styles.itemText}>
        <Text as="span" weight="medium">
          {title}
        </Text>
        {subtitle && (
          <Text as="span" color="muted">
            {subtitle}
          </Text>
        )}
      </div>
      <div className={styles.itemActions}>
        {onSnooze && (
          <IconButton
            icon={IconClock}
            label={snoozeTooltip}
            onClick={onSnooze}
          />
        )}
        {onAction && (
          <IconButton
            icon={IconArrowRight}
            label={actionTooltip}
            variant="primary"
            onClick={onAction}
          />
        )}
        {onDelete && (
          <IconButton
            icon={IconTrash}
            label={deleteTooltip}
            onClick={onDelete}
          />
        )}
      </div>
    </div>
  );
}
